import APP_ACTIONS from '../constants/app-actions';
import WalletsAPI from '../apis/wallets';
import localStorageAPI from '../services/local-storage-api';

export default {
    fetchWalletTransactions: (params, wallet, token) => (dispatch, getState) => WalletsAPI.getWalletTransactions({
        wallet,
        token,
        params,
    }),
    fetchWalletDetails: (wallet, token) => (dispatch, getState) => WalletsAPI.getWalletDetails({
        wallet,
        token,
    }),
    activeWallet: (wallet, token, forceCheck = false) => async (dispatch, getState) => {
        const { wallets } = getState();
        if (typeof wallets[wallet] === 'boolean' && !forceCheck) {
            return wallets[wallet];
        }
        wallets[wallet] = await WalletsAPI.getWalletIsActive({
            wallet,
            token,
        });
        dispatch({
            type: APP_ACTIONS.UPDATE_WALLETS,
            payload: wallets,
        });
        localStorageAPI.save(getState());
        return wallets[wallet];
    },
    activateWallet: (wallet, token) => (dispatch, getState) => (
        WalletsAPI.activateWallet({
            wallet,
            token,
        }).then((response) => {
            const { wallets } = getState();
            wallets[wallet] = true; // response.value;
            dispatch({
                type: APP_ACTIONS.UPDATE_WALLETS,
                payload: wallets,
            });
            localStorageAPI.save(getState());
            return true;
        }).catch((error) => false)
    ),
    transferWalletFunds: ({
        wallet, token, amount, idTransfer,
    }) => (dispatch, getState) => WalletsAPI.sendFunds({
        wallet, token, amount, idTransfer,
    }),
};



/** WEBPACK FOOTER **
 ** ./src/actions/wallets.js
 **/